<template>
  <modal
    :name="name"
    :scrollable="true"
    :focusTrap="focusTrap"
    :reset="true"
    :width="width"
    height="auto"
    class="modal uk-flex-top"
    @closed="close"
    v-on="$listeners"
  >
    <div class="uk-margin-auto-vertical">
      <span class="modal-close" type="button" @click="$modal.hide(name)">
        <i uk-icon="icon:close"></i>Закрыть</span
      >
      <div class="dialog">
        <slot></slot>
        <div v-if="$slots.header" class="dialog-header">
          <slot name="header"></slot>
        </div>
        <div v-if="$slots.content" class="dialog-content">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'b-dialog',
  props: {
    name: {
      type: String,
      required: true
    },
    width: {
      type: [Number, String],
      default: 600
    },
    focusTrap: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    close() {
      this.$modal.hide(this.name)
    }
  }
}
</script>

<style lang="scss">
.v--modal,
.vm--modal {
  padding: 30px 30px !important;
  border: 1px solid rgba(34, 34, 34, 0.05) !important;
  border-radius: 10px !important;
  min-width: 400px;
  max-width: 90vw;
}

.modal {
  &.v--modal-overlay .v--modal-box {
    overflow: inherit;
  }

  &-dialog {
    padding: 30px 30px;
    border: 1px solid rgba(34, 34, 34, 0.05);
    border-radius: 10px;
    width: auto !important;
    min-width: 400px;
    max-width: 90vw;
  }

  &-header {
    padding-top: 0;
    padding-left: 0;
    border-bottom: 1px solid #e5e5e5;
  }

  &-title {
    font-size: 1.5rem;
    line-height: 1;
    color: #000000;
    margin-bottom: 17px;
  }

  &-subtitle {
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.125;
    color: rgba(34, 34, 34, 0.6);

    label {
      display: inline-block;
      margin-bottom: 20px;
    }
  }

  &-content {
    padding-top: 20px;
  }

  &-close {
    position: absolute;
    display: flex;
    align-items: center;
    top: 32px;
    right: 18px;
    cursor: pointer;
    z-index: 1010;

    svg {
      margin-right: 12px;
    }
  }

  &--content {
    .dialog {
      width: auto;
    }
  }
}

.dialog {
  &-header {
    margin-top: 50px;
    text-align: center;
    font-size: 1.5rem;
    line-height: 1;
    color: #000000;
  }

  &-content {
    padding: 40px 40px 0;
    text-align: center;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.125;
    color: rgba(34, 34, 34, 0.6);
  }
}
</style>
